import * as v from 'valibot'

const Count = v.pipe(v.number(), v.integer(), v.minValue(0))

/**
 * 对白配音请求（POST /api/novel/runs/:id/tts，C3）：只收段落 id。文本与说话人由服务端从对局活动分支里取该段，
 * 段不存在或玩家不在它的 audience 里 NOT_FOUND segment_not_found；音色由服务端按作品 voices_json[speaker_id] 定，
 * 缺失时用平台第一条启用的音色（M4）。计费幂等键 `novel-tts:<run_id>:<segment_id>:<voice_id>`（上限 191 字符，
 * segment_id 因此限 60）：同一段同一音色只结算一次，刷新后重播不再扣费。
 * @typedef {{ segment_id: string }} NovelTtsBodyT
 */
export const NovelTtsBody = v.object({
  segment_id: v.pipe(v.string(), v.minLength(1), v.maxLength(60)),
})

/**
 * 配音 NDJSON 事件：audio*（base64 mp3 分片，seq 从 1 起）→ done；失败以 error 结束（error_code 为 TTS 原因码或小写平台码）。
 * 完整音频由服务端私有保存；缓存回放沿用相同事件，charged_points 为 0。
 */
export const NovelTtsEvent = v.union([
  v.object({ type: v.literal('audio'), seq: Count, data: v.pipe(v.string(), v.minLength(1)) }),
  v.object({
    type: v.literal('done'),
    chunk_count: Count,
    audio_bytes: Count,
    voice_id: v.string(),
    model: v.nullable(v.string()),
    request_id: v.nullable(v.string()),
    charged_points: v.number(),
  }),
  v.object({
    type: v.literal('error'),
    error_code: v.string(),
    error: v.optional(v.string()),
    retryable: v.optional(v.boolean()),
    required_points: v.optional(v.number()),
    current_balance: v.optional(v.number()),
    shortfall_points: v.optional(v.number()),
  }),
])
